"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardTabsViewController = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const TabList_1 = require("../../../TabList");
class WizardTabsViewController extends core_1.ReactViewController {
    constructor() {
        super(...arguments);
        this.tabs = new Map();
    }
    getTabElement(id) {
        const tab = this.tabs.get(id);
        if (!tab) {
            return null;
        }
        return tab.render() || null;
    }
    createElement({ navigation, pending = false }) {
        return (react_1.default.createElement(TabList_1.TabList, { width: this.width, items: navigation.map(({ id, active, disabled }) => {
                const isDisabled = active ? disabled : disabled || pending;
                return {
                    onClick: () => {
                        if (!isDisabled) {
                            this.listener && this.listener.didSelectStepById(id);
                        }
                    },
                    active,
                    disabled: isDisabled,
                    render: () => this.getTabElement(id)
                };
            }) }));
    }
    present(state) {
        this.setState(state);
    }
    registerTab(id, viewController) {
        this.tabs.set(id, viewController);
    }
    presentPending({ pending }) {
        const prevState = this.getState();
        if (prevState) {
            this.setState(Object.assign(Object.assign({}, prevState), { pending }));
        }
    }
}
exports.WizardTabsViewController = WizardTabsViewController;
//# sourceMappingURL=WizardTabsViewController.js.map